/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cna_Result_No_AnswerInputs */

const en_cna_result_no_answer = /** @type {(inputs: Cna_Result_No_AnswerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No answer`)
};

const ja_cna_result_no_answer = /** @type {(inputs: Cna_Result_No_AnswerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`応答なし`)
};

const fr_cna_result_no_answer = /** @type {(inputs: Cna_Result_No_AnswerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pas de réponse`)
};

const de_cna_result_no_answer = /** @type {(inputs: Cna_Result_No_AnswerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keine Antwort`)
};

/**
* | output |
* | --- |
* | "No answer" |
*
* @param {Cna_Result_No_AnswerInputs} inputs
* @param {{ locale?: "en" | "ja" | "fr" | "de" }} options
* @returns {LocalizedString}
*/
export const cna_result_no_answer = /** @type {((inputs?: Cna_Result_No_AnswerInputs, options?: { locale?: "en" | "ja" | "fr" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cna_Result_No_AnswerInputs, { locale?: "en" | "ja" | "fr" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_cna_result_no_answer(inputs)
	if (locale === "ja") return ja_cna_result_no_answer(inputs)
	if (locale === "fr") return fr_cna_result_no_answer(inputs)
	return de_cna_result_no_answer(inputs)
});